export default __webpack_public_path__ + "static/media/ndpr-audit-hil.82ff83df.png";